import React, { useState, useEffect } from 'react';
import localforage from "localforage";

/* We also set this in index.css */
const DEFAULT_FONT_SIZE = '16px';

// import { observer } from 'mobx-react-lite';
const KEYS = {
    sunrise: 'sunrise',
    fontSize: 'fontSize'
};


export type FunContextType = {
    sunrise: boolean,
    setSunrise?: (sunrise: boolean) => void;
    fontSize?: string;
    setFontSize?: (fontSize: string) => void;
    DEFAULT_FONT_SIZE?: string;
}

export const FunContext = React.createContext<FunContextType>({
    sunrise: false,
    setSunrise: () => {},
    fontSize: DEFAULT_FONT_SIZE,
    setFontSize: () => {},
    DEFAULT_FONT_SIZE: DEFAULT_FONT_SIZE
});

export const FunProvider = function({ children }: { children: React.ReactNode })  {
    const [sunrise, setStateSunrise] = useState(false);
    const [fontSize, setStateFontSize] = useState(DEFAULT_FONT_SIZE);
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        if(!loaded) {
            setLoaded(true);
            localforage.getItem<boolean>(KEYS.sunrise).
                then((data) => {
                    setSunrise(data || false);
                });

            localforage.getItem<string>(KEYS.fontSize).
                then((data) => {
                    setFontSize(data || DEFAULT_FONT_SIZE);
                });
        }
    }, [loaded, setLoaded]);


    function setSunrise(sunrise: boolean) {
        setStateSunrise(sunrise);
        localforage.setItem(KEYS.sunrise, sunrise);
    }

    function setFontSize(value: string) {
        setStateFontSize(value);
        localforage.setItem(KEYS.fontSize, value);
    }

    const data = {
        sunrise: sunrise,
        setSunrise: setSunrise,
        fontSize: fontSize,
        setFontSize: setFontSize,
        DEFAULT_FONT_SIZE
    };

    return (
        <FunContext.Provider value={data}>{ children }</FunContext.Provider>
    );

};
